<template>
  <a-card :bordered="false">

    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">

          <a-col :xl="10" :lg="11" :md="12" :sm="24">
            <a-form-item :label="language['eletronicSigned.treatmentDate']">
              <j-date :placeholder="language['common.chooseStartDate']" :showTime="false"
                      :allowClear="false"
                      :defaultValue="moment(queryParam.beginDate, 'YYYY-MM-DD')" dateFormat="YYYY-MM-DD"
                      class="query-group-cust" v-model="queryParam.beginDate"></j-date>
              <span class="query-group-split-cust"></span>
              <j-date :placeholder="language['common.chooseEndDate']" :showTime="false"
                      :allowClear="false"
                      :defaultValue="moment(queryParam.endDate, 'YYYY-MM-DD')" dateFormat="YYYY-MM-DD"  class="query-group-cust" v-model="queryParam.endDate"></j-date>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="12">
            <a-form-item :label="language['eletronicSigned.processName']">
              <!--<a-input placeholder="请输入账号查询" v-model="queryParam.username"></a-input>-->
              <!--<j-input placeholder="输入流程名称" v-model="queryParam.realname"></j-input>-->
              <a-select v-model="queryParam.model_guid" allowClear >
                <a-select-option v-for="(process,index) in allProcess" :key="index" :value="process.processModelGuid" >{{ process.processModelName }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item :label="language['eletronicSigned.businessFormNo']">
              <a-input  v-model="queryParam.business_form_no"></a-input><!--placeholder="输入流程编号"-->
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item :label="language['eletronicSigned.creater']">
              <a-input  v-model="queryParam.create_user_name"></a-input><!--placeholder="输入流程编号"-->
            </a-form-item>
          </a-col>
          <!--<a-col :md="6" :sm="12">
            <a-form-item :label="language['eletronicSigned.affiliationApplication']">
              <a-select v-model="queryParam.application_code" allowClear >
                <a-select-option v-for="(process,index) in allApplication" :key="index" :value="process.processApplicationCode" >{{ process.processApplicationName }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>-->

          <a-col :md="6" :sm="8">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{language['common.searchButton']}}</a-button>
              <a-button type="primary" @click="search_reset" icon="reload" style="margin-left: 8px">{{language['common.resetButton']}}</a-button>
              <a-button type="primary" @click="downloadExcelReport" icon="download" style="margin-left: 8px" v-if="application === 'ipsystbs'">{{language['common.exportButton']}}</a-button>
             <!-- <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>-->
            </span>
          </a-col>

        </a-row>
      </a-form>
    </div>

    <!-- table区域-begin -->
    <div>
      <!--<div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i>已选择&nbsp;<a style="font-weight: 600">{{
        selectedRowKeys.length }}</a>项&nbsp;&nbsp;
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>-->

      <a-table
        ref="table"
        bordered
        size="middle"
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        @change="handleTableChange"
        :scroll="{x:2000}">
        <!--:rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"-->

        <template slot="processChartLot" slot-scope="text, record, index">
          <div class="anty-img-wrap">
            <!--<a-avatar @click="openChart(record.process_guid)" shape="square" icon="user"/>-->
            <a-icon type="cluster" @click="openChart(record.process_guid)" style="color:#33A1FF"/>
            <j-modal
              switchFullscreen
              :mask="false"
              :width="1000"
              :title="language['eletronicSigned.processChart']"
              :visible="visible"
              :confirm-loading="confirmLoading"
              :ok-button-props="{ props: { disabled: true } }"
              @cancel="handleCancel"
              :ok-disabled="true"
              :cancelText="language['common.closeButton']">
              <img style="width: 100%;" :src="imgChartSrc"><!--'be00c9ad-45e8-a5c4-9c83-1523494a8a70'-->
            </j-modal>
          </div>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">{{language['common.detailsButton']}}</a>
          <!--<a-divider type="vertical"/>
          <a-dropdown>
            <a class="ant-dropdown-link">
              更多 <a-icon type="down"/>
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a href="javascript:;" @click="handleDetail(record)">详情</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>-->
        </span>
        <span slot="processStatus" slot-scope="text, record">
          {{ text === 'Cancelled' ? language['eletronicSigned.termination'] : ((langCode === "zh_CN" || langCode === "zh_TW")?record.process_status_local_lang:record.process_status) }}
        </span>
        <span slot="task_status" slot-scope="text, record">
          {{ text === 'Cancelled' ? language['eletronicSigned.termination'] : ((langCode === "zh_CN" || langCode === "zh_TW")?record.task_status_local_lang:record.task_status) }}
        </span>

      </a-table>
    </div>
    <!-- table区域-end -->

    <my-finished-modal ref="modalForm" @ok="modalFormOk"></my-finished-modal>

  </a-card>
</template>
<script>
  import { ACCESS_TOKEN,USER_LANGUAGE } from "@/store/mutation-types"
  import MyFinishedModal from '@/views/eletronicSigned/modules/MyFinishedModal'
  import {putAction, getFileAccessHttpUrl,getAction} from '@/api/manage';
  import {frozenBatch} from '@/api/api'
  import {JeecgListMixin} from '@/mixins/JeecgListMixin'
  import JInput from '@/components/jeecg/JInput'
  import JSuperQuery from '@/components/jeecg/JSuperQuery'
  import moment from 'moment'
  import {GroupType}  from '@/views/intellectualProperty/getRoleCode.js'
  export default {
    name: "MyFinishedList",
    mixins: [JeecgListMixin,GroupType],
    components: {
      MyFinishedModal,
      JInput,
      JSuperQuery
    },
    data() {
      return {
        langCode:window.sessionStorage.getItem(USER_LANGUAGE),
        allProcess:[],
        allApplication:[],
        application:'',
        ipsysParmas:{menueKey:'TBSManage',purepose:'',systemType:'ipsystbs',formId:'',fromNo:'',url:''},
        imgChartSrc:"",
        processChartPrefix: "",
        processChartSuffix: "",
        processGuid: "",
        visible: false,
        confirmLoading: false,
        queryParam: {
          model_guid:"",
          business_form_no:"",
          create_user_name:"",
          application_code:this.$store.getters.applicationCode,
          // userCode: "W0888888",
          userCode:this.$store.getters.userInfo.userType==='employee'?this.$store.getters.userInfo.workNo:this.$store.getters.userInfo.username,
          taskListType: "AllFinished",
          beginDate: this.getBeginDate(),
          endDate: this.getEndDate(),

        },
        recycleBinVisible: false,
        url: {
          list: "/sys/wfapi/getTaskList",
          // list: "/sys/user/list",
          exportXlsUrl:'/ipsys/bs/bsApply/exportTbsXls'
        },
        /* 分页参数 */
        ipagination:{
          current: 1,
          pageSize: 10,
          pageSizeOptions: ['10', '20', '30'],
          showTotal: (total, range) => {
            return range[0] + "-" + range[1] +" "+ this.$store.getters.language['common.total']+" " + total +" "+ this.$store.getters.language['common.strip']
          },
          showQuickJumper: true,
          showSizeChanger: true,
          total: 0
        },
      }
    },
    created() {
        this.initAllprocessAndapplication();
      getAction("/sys/wfapi/getProcessChart",{}).then(res=>{
        if (res.success) {
          this.processChartPrefix=res.result.prefix;
          this.processChartSuffix = res.result.suffix;
        }
      })
  },
  computed: {
    language() {
      return this.$store.getters.language;
    },
    columns() {
      if (this.language) {
        return [
          {
            title: this.language['eletronicSigned.processName'],
            align: "center",
            dataIndex: 'process_name_local_lang',
            width: 200,
            sorter: true,
            customCell: () => {
              return {
                style: {
                  'text-align': 'left'
                },
              };
            },
            customRender: function (text, r, index) {
              if(window.sessionStorage.getItem(USER_LANGUAGE) === "zh_CN" || window.sessionStorage.getItem(USER_LANGUAGE) === "zh_TW"){
                return r.process_name_local_lang;
              }else{
                return r.process_name_en;
              }
            }
          },
          {
            title: this.language['eletronicSigned.processStatus'],
            align: "center",
            width: 180,
            dataIndex: 'process_status',
            // customRender: function (text, r, index) {
            //   if (text === 'Cancelled') {
            //     // return this.tt.language['eletronicSigned.termination']
            //     // return this.termination;
            //     // return '终止'
            //     // return this.getLanguage('eletronicSigned.termination')
            //     return this.language['eletronicSigned.processName'];
            //     // return this.language('eletronicSigned.termination');
            //   } else {
            //     return r.process_status_local_lang;
            //   }
            // }
            scopedSlots: {customRender: 'processStatus'},
          },
          {
            title: this.language['eletronicSigned.businessFormNo'],
            align: "center",
            width: 200,
            dataIndex: 'business_form_no',
            customCell: () => {
              return {
                style: {
                  'text-align': 'left'
                },
              };
            },
          },
          {
            title: this.language['eletronicSigned.taskText'],
            align: "center",
            width: 150,
            dataIndex: 'task_text_local_lang',
            customCell: () => {
              return {
                style: {
                  'text-align': 'left'
                },
              };
            },
            customRender: function (text, r, index) {
              if(window.sessionStorage.getItem(USER_LANGUAGE) === "zh_CN" || window.sessionStorage.getItem(USER_LANGUAGE) === "zh_TW"){
                return r.task_text_local_lang;
              }else{
                return r.task_text_en;
              }
            }
          },
          {
            title: this.language['eletronicSigned.taskStatus'],
            align: "center",
            width: 150,
            dataIndex: 'task_status',
            scopedSlots: {customRender: 'task_status'},
            /*customRender: function (text, r, index) {
              if (text === 'Cancelled') {
                return this.language['eletronicSigned.termination']
              } else {
                return r.task_status_local_lang;
              }
            }*/
          },
          {
            title: this.language['eletronicSigned.createUserName'],
            align: "center",
            width: 150,
            dataIndex: 'create_user_name'
          },
          {
            title: this.language['eletronicSigned.startTime'],
            align: "center",
            width: 150,
            dataIndex: 'create_time'
          },
          {
            title: this.language['eletronicSigned.processChart'],
            align: "center",
            width: 100,
            dataIndex: 'process_guid',
            scopedSlots: {customRender: "processChartLot"}
          },
          /*{
            title: this.language['eletronicSigned.urgentDegree'],
            align: "center",
            width: 150,
            dataIndex: 'urgent_degree'
          },*/
          {
            title: this.language['eletronicSigned.approveResult'],
            align: "center",
            width: 160,
            dataIndex: 'approveResult',
            customCell: () => {
              return {
                style: {
                  'text-align': 'left'
                },
              };
            },
            customRender: function (text, r, index) {
              if(window.sessionStorage.getItem(USER_LANGUAGE) === "zh_CN" || window.sessionStorage.getItem(USER_LANGUAGE) === "zh_TW"){
                return r.approveResult;
              }else{
                return r.approveResult_en;
              }
            }
          },
          {
            title: this.language['eletronicSigned.approveName'],
            align: "center",
            width: 160,
            dataIndex: 'approveName',
            customCell: () => {
              return {
                style: {
                  'text-align': 'left'
                },
              };
            },
          },
          {
            title: this.language['eletronicSigned.approveDate'],
            align: "center",
            dataIndex: 'approveDate'
          },
          {
            title: this.language['common.action'],
            dataIndex: 'action',
            scopedSlots: {customRender: 'action'},
            align: "center",
            width: 170,
            fixed: "right"
          }

        ]
      }
    }
  },
  methods: {
    moment,
    getAvatarView: function (avatar) {
      return getFileAccessHttpUrl(avatar)
    },
    openChart(process_guid) {
      this.visible = true;
      this.imgChartSrc = this.processChartPrefix + process_guid + this.processChartSuffix;
      if(this.imgChartSrc.split("?").length>1){
        this.imgChartSrc = this.imgChartSrc + "&timestamp="+ new Date().getTime();
      }else{
        this.imgChartSrc = this.imgChartSrc + "?timestamp="+ new Date().getTime();
      }
    },
    handleCancel(e) {
      this.visible = false;
    },
    initAllprocessAndapplication(){
      getAction("/sys/processSigned/pfBpmModel/listWithOutPage", {applicationCode:this.$store.getters.applicationCode}).then((res) => {
        if (res.success) {
          let processlist = [];
          let applicationlist = [];
          let set = [];
          res.result.forEach(item=>{
            let processmap = {};
            processmap.processModelGuid = item.modelGuid;
            if(window.sessionStorage.getItem(USER_LANGUAGE) === "zh_CN" || window.sessionStorage.getItem(USER_LANGUAGE) === "zh_TW"){
              processmap.processModelName = item.modelNameLocalLang;
            }else{
              processmap.processModelName = item.modelNameEn;
            }
            processlist.push(processmap);
            if(set.indexOf(item.applicationCode) === -1){
              let applicationmap = {};
              applicationmap.processApplicationCode = item.applicationCode;
              applicationmap.processApplicationName = item.applicationName;
              applicationlist.push(applicationmap);
              set.push(item.applicationCode);
            }
          })
          this.allProcess = processlist;
          this.allApplication = applicationlist;
          this.application=applicationlist[0].processApplicationCode;
        } else {
        }
      })
    },
    search_reset() {
      /*this.queryParam = {
        taskListType: "AllMyRequest",
        beginDate: new Date(),
        endDate: new Date(),
      };*/
      this.queryParam ={
          model_guid:"",
          business_form_no:"",
          create_user_name:"",
          application_code:this.$store.getters.applicationCode,
          userCode:this.$store.getters.userInfo.userType==='employee'?this.$store.getters.userInfo.workNo:this.$store.getters.userInfo.username,
          taskListType: "AllFinished",
          beginDate: this.getBeginDate(),
          endDate: this.getEndDate(),

      },
      this.loadData(1);
    },
    getBeginDate(){
      let date= new Date();
      date.setMonth(date.getMonth() - 1)
      let day = date.getDate()>9?date.getDate():'0'+date.getDate();
      // let month = date.getMonth()>9?date.getMonth():(date.getMonth()!==0?'0'+date.getMonth():0);
      let month = date.getMonth()+1>9?date.getMonth()+1:'0'+(date.getMonth()+1);
      let year = date.getFullYear();
      /*if(month===0){
        year = year-1;
        month = 12;
      }*/
      return year+'-'+month+'-'+day;
    },
    getEndDate(){
      let date= new Date();
      let day = date.getDate()>9?date.getDate():'0'+date.getDate();
      let year = date.getFullYear()
      let month = date.getMonth()+1>9?date.getMonth()+1:'0'+(date.getMonth()+1);
      return year+'-'+month+'-'+day+' 23:59:59';
    },
    downloadExcelReport(){
      this.$set(this.queryParam, 'excelReportType', '2') 
      this.$set(this.queryParam, 'startDate',  this.queryParam.beginDate)      
      this.handleExportXls("技术营业秘密文件")      
      this.ipsysParmas.purepose='导出技术性营业秘密'
      this.saveInforLog(this.ipsysParmas) 
    }
  }

  }
</script>

<style scoped>
  @import '~@assets/less/common.less'
</style>